module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/banner-3970ed864f70ed830be01440e202f27c.png";